import { render, staticRenderFns } from "./user_sign.vue?vue&type=template&id=0b764da0&scoped=true&"
import script from "./user_sign.vue?vue&type=script&lang=js&"
export * from "./user_sign.vue?vue&type=script&lang=js&"
import style0 from "./user_sign.vue?vue&type=style&index=0&id=0b764da0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b764da0",
  null
  
)

export default component.exports